import { PrismicRichText } from '@prismicio/react';
import IconShieldCheck from '@remote-com/norma/icons/shield-check.svg';
import { useRef } from 'react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import HeaderContext from 'remote-com-shared/components/Header/context';
import { NavigationSecondary } from 'remote-com-shared/components/HeaderNavigation/styles/Navigation';
import { Hero } from 'remote-com-shared/components/Hero';
import { ImageBackgroundStyle } from 'remote-com-shared/components/Hero/styles';
import { TwoStepFormModalButton } from 'remote-com-shared/components/TwoStepForm';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { GatedContentSection } from './GatedContent';
import HalfIconImage from './assets/half-icon-logo-left.png';
import HeroIllustrationImage from './assets/hero-illustration.svg';
import {
  SectionWrapper,
  SectionTitle,
  SectionHeader,
  SectionDescription,
  IconShieldWrapper,
} from './styles';

import { SinglePageScrollLayout } from '@/layouts/SinglePageScrollLayout';
import { Header } from '@/src/components/Header';
import { defaultPrismicComponents } from '@/src/domains/prismic/render';
import { fromDesktopBreakpoint, tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const HeroIllustration = styled(HeroIllustrationImage)`
  ${ImageBackgroundStyle}
  right: 0;
  bottom: 0;
  width: 90%;
  height: auto;

  ${tabletBreakpoint(css`
    display: none;
  `)}

  ${fromDesktopBreakpoint(css`
    max-width: 40%;
  `)}
`;

const HalfLogo = styled.img.attrs({
  src: HalfIconImage.src,
  alt: '',
})`
  position: absolute;
  ${fluidProp('height', '200px', '354px')}
  left: 0;
  ${fluidProp('top', '-75px', '-125px')}
`;

const RecommendAdvocate = ({ title, description }) => (
  <SectionWrapper $tone="light">
    <HalfLogo />

    <ContentContainer>
      <SectionHeader>
        <IconShieldWrapper>
          <IconShieldCheck />
        </IconShieldWrapper>
        <SectionTitle>
          <PrismicRichText field={title} />
        </SectionTitle>
      </SectionHeader>
      <SectionDescription>
        <PrismicRichText field={description} components={defaultPrismicComponents} />
      </SectionDescription>
    </ContentContainer>
  </SectionWrapper>
);

export function GDPRRequestErasureView({ pageData, hubspotFormDefinition }) {
  const headerRef = useRef(null);
  const {
    hero_title: heroTitle,
    hero_description: heroDescription,
    introduction_title: introductionTitle,
    introduction_description: introductionDescription,
    modal_form_title: formTitle,
    modal_form_description: formDescription,
    recommend_title: recommendTitle,
    recommend_description: recommendDescription,
    gated_file: gatedFile,
  } = pageData;

  return (
    <>
      <DocumentHead document={pageData} />
      <HeaderContext.Provider value={headerRef}>
        <Header ref={headerRef} hideBanner>
          <NavigationSecondary>
            <TwoStepFormModalButton>Talk with us</TwoStepFormModalButton>
          </NavigationSecondary>
        </Header>
        <Hero
          title={<PrismicRichText field={heroTitle} />}
          description={<PrismicRichText field={heroDescription} />}
          preview="0vh"
          background={<HeroIllustration />}
        />

        <GatedContentSection
          title={introductionTitle}
          description={introductionDescription}
          gatedFile={gatedFile}
          gatedFileDownloadLabel="Download report"
          formTitle={formTitle}
          formDescription={formDescription}
          hubspotFormDefinition={hubspotFormDefinition}
        />
        <RecommendAdvocate title={recommendTitle} description={recommendDescription} />
      </HeaderContext.Provider>
    </>
  );
}

GDPRRequestErasureView.Layout = SinglePageScrollLayout;
